import _ from 'underscore';

import {SchemaFieldSelectorsDict} from 'notebook/structured-tables/hooks/useSelectorsById';
import {DefaultValuesByColumnType} from 'notebook/structured-tables/StructuredTableConstants';
import {ProcessTableLocation} from 'processes/ProcessConstants';
import createTaskTable, {CreateTaskTableSchemaParams} from 'processes/tables/createTaskTable';
import {ProcessTaskStructuredTable} from 'processes/tables/ProcessTaskStructuredTableAdapter';

import ProcessTaskStructuredTableAdapter from './ProcessTaskStructuredTableAdapter';

interface CreateEmptyTaskTableFromSchemaParams {
  name: string;
  taskSchema: CreateTaskTableSchemaParams;
  tableLocation: ProcessTableLocation;
  locked?: boolean;
  selectorsById: SchemaFieldSelectorsDict;
  isInFlowchartNode?: boolean;
  defaultValuesByColumnType?: DefaultValuesByColumnType;
}

export function createEmptyTaskTableFromSchemaWithEmptyRows({
  numRows = 0,
  ...params
}: CreateEmptyTaskTableFromSchemaParams & {numRows?: number}): ProcessTaskStructuredTable {
  const adapter = ProcessTaskStructuredTableAdapter.getAdapter();
  const table = createEmptyTaskTableFromSchema(params);

  return {
    ...table,
    rows: _.range(0, numRows).map((rowIndex) => adapter.getBlankRow(table.metadata, rowIndex, table.columns)),
  };
}

export default function createEmptyTaskTableFromSchema({
  name,
  taskSchema,
  tableLocation,
  locked,
  selectorsById,
  isInFlowchartNode,
  defaultValuesByColumnType,
}: CreateEmptyTaskTableFromSchemaParams): ProcessTaskStructuredTable {
  const taskTable = createTaskTable({
    process: {
      id: taskSchema.id,
      name: taskSchema.name,
      processTaskSchema: {
        ...taskSchema,
        name,
      },
      tasks: [],
    },
    tableLocation,
    selectorsById,
    locked,
    isInFlowchartNode,
    defaultValuesByColumnType,
  });
  return taskTable;
}
